import React from "react";
import CustomerSuccessAdminAssociatedBrands from "components/cs-admin/customer-success-admin-associated-brands";
import CustomerSuccessAdminCsvExport from "components/cs-admin/customer-success-admin-csv-export";
import CustomerSuccessAdminDisableBrand from "components/cs-admin/customer-success-admin-disable-brand";
import CustomerSuccessAdminEmailOverlap from "components/cs-admin/customer-success-admin-email-overlap";
import CustomerSuccessAdminEntries from "components/cs-admin/customer-success-admin-entries";
import CustomerSuccessAdminEntrySeeder from "components/cs-admin/customer-success-admin-entry-seeder";
import CustomerSuccessAdminEspResults from "components/cs-admin/customer-success-admin-esp-results";
import CustomerSuccessAdminImpersonate from "components/cs-admin/customer-success-admin-impersonate";
import CustomerSuccessAdminPartnershipEditor from "components/cs-admin/customer-success-admin-partnership-editor";
import CustomerSuccessAdminSuccessPageProportion from "components/cs-admin/customer-success-admin-success-page-proportion";
import CustomerSuccessAdminUnlockUser from "components/cs-admin/customer-success-admin-unlock-user";
import CustomerSuccessAdminFeatureFlags from "components/cs-admin/customer-success-feature-flag";
import { connect } from "react-redux";
import { Link, Route, Switch, withRouter } from "react-router-dom";
import Card from "react-toolbox/lib/card";
import { H2, P } from "visual-components/util/texts";
import CSAdminSearchAccount from "../cs-admin/search-account";
import CSAdminBrandManager from "./brand-manager";
import CSAdminCMS from "./cms/cms";
import CSAdminCreateOrEditContent from "./cms/createContent";
import CSAdminBrandRatings from "./customer-success-admin-brand-ratings";
import CSAdminMailchimpDoubleOptIn from "./customer-success-admin-mailchimp-double-optin";
import CustomerSuccessAdminMarkBrandsInterested from "./customer-success-admin-mark-brands-interested";
import CSAdminUpdateBrandName from "./customer-success-admin-update-brand-name";
import CSAdminEditCampaignLaunch from "./customer-success-edit-campaign-launch";
import CSAdminEntriesManager from "./entries-manager";
import CSAdminSweepsManager from "./entries-manager/sweeps";

class CustomerSuccessAdminContainer extends React.Component {
  componentDidMount() {
    const { profile, history } = this.props;
    if (!profile.isAdmin) {
      history.replace("/app");
    }
  }

  render() {
    const {
      match: {
        params: { section },
      },
    } = this.props;

    if (section) {
      return (
        <Switch>
          <Route exact path="/cs-admin/brands" component={CSAdminBrandManager} />
          <Route exact path="/cs-admin/entries" component={CSAdminEntriesManager} />
          <Route exact path="/cs-admin/sweeps" component={CSAdminSweepsManager} />
          <Route exact path="/cs-admin/search-account" component={CSAdminSearchAccount} />
          <Route exact path="/cs-admin/cms" component={CSAdminCMS} />
          <Route exact path="/cs-admin/content" component={CSAdminCreateOrEditContent} />
          <Route exact path="/cs-admin/content/edit/:id" component={CSAdminCreateOrEditContent} />
          <Route exact path="/cs-admin/content/view/:id" component={CSAdminCreateOrEditContent} />
        </Switch>
      );
    }

    return (
      <div
        className="container"
        style={{
          marginTop: "50px",
          marginBottom: "50px",
        }}
      >
        <CustomerSuccessAdminEntries />
        <CustomerSuccessAdminImpersonate />
        <CustomerSuccessAdminPartnershipEditor />
        <hr />
        <CustomerSuccessAdminSuccessPageProportion />
        <hr />
        <CustomerSuccessAdminCsvExport />
        {/* Display Seed Entries UI for development and staging environments */}
        {process.env.NODE_ENV !== "production" && (
          <>
            <hr />
            <CustomerSuccessAdminEntrySeeder />
          </>
        )}
        <hr />
        <CustomerSuccessAdminEmailOverlap />
        <hr />
        <CustomerSuccessAdminEspResults />
        <hr />
        <CustomerSuccessAdminMarkBrandsInterested />
        <hr />
        <CSAdminUpdateBrandName />
        <hr />
        <CustomerSuccessAdminAssociatedBrands />
        <hr />
        <CustomerSuccessAdminDisableBrand />
        <hr />
        <CustomerSuccessAdminFeatureFlags />
        <hr />
        <CustomerSuccessAdminUnlockUser />
        <hr />
        <CSAdminBrandRatings />
        <hr />
        <CSAdminMailchimpDoubleOptIn />
        <hr />
        <CSAdminEditCampaignLaunch />
        <hr />
        <Link to="/cs-admin/brands">
          <Card
            style={{
              padding: "24px",
              marginBottom: "16px",
              cursor: "pointer",
            }}
          >
            <H2 azure>Brand Manager</H2>
            <P multiline>- Add/Update Preferred Terms Plans</P>
            <P multiline>- Cancel Current Plan</P>
          </Card>
        </Link>
        <a href="/app/admin/featured-brands" style={{ textDecoration: "none" }}>
          <Card
            style={{
              padding: "24px",
              marginBottom: "16px",
              cursor: "pointer",
            }}
          >
            <H2 azure>Featured Brands</H2>
            <P multiline>- Select brands to feature on discover page</P>
            <P multiline>- Manage featured brands order</P>
          </Card>
        </a>
        <a href="/app/admin/delete-user" style={{ textDecoration: "none" }}>
          <Card
            style={{
              padding: "24px",
              marginBottom: "16px",
              cursor: "pointer",
            }}
          >
            <H2 azure>Delete User Account</H2>
            <P multiline>- Permanently delete test/spam accounts</P>
            <P multiline>- Removes user, sole-owned brands, and Stripe data</P>
          </Card>
        </a>
        <a href="/app/admin/delete-brand" style={{ textDecoration: "none" }}>
          <Card
            style={{
              padding: "24px",
              marginBottom: "16px",
              cursor: "pointer",
            }}
          >
            <H2 azure>Delete Brand</H2>
            <P multiline>- Permanently delete a brand and all associated data</P>
            <P multiline>- Removes brand records, Stripe data, and detaches users</P>
          </Card>
        </a>
        <Link to="/cs-admin/entries">
          <Card
            style={{
              padding: "24px",
              marginBottom: "16px",
              cursor: "pointer",
            }}
          >
            <H2 azure>- Entries Report Manager</H2>
            <P multiline>- Entries Tracking/Download Section</P>
          </Card>
        </Link>
        <Link to="/cs-admin/sweeps">
          <Card
            style={{
              padding: "24px",
              marginBottom: "16px",
              cursor: "pointer",
            }}
          >
            <H2 azure>- All Sweeps Views</H2>
            <P multiline>- List of sweeps with status</P>
          </Card>
        </Link>
        <Link to="/cs-admin/search-account">
          <Card
            style={{
              padding: "24px",
              marginBottom: "16px",
              cursor: "pointer",
            }}
          >
            <H2 azure>- User Account Management</H2>
            <P multiline>- Alter user account like email , password, first name etc.</P>
            <P multiline>- Search brands by brand name, owner name and email</P>
          </Card>
        </Link>
        <Link to="/cs-admin/cms">
          <Card
            style={{
              padding: "24px",
              marginBottom: "16px",
              cursor: "pointer",
            }}
          >
            <H2 azure>Content Management System</H2>
          </Card>
        </Link>
      </div>
    );
  }
}

const mapState = function (state) {
  return state;
};

export default withRouter(connect(mapState)(CustomerSuccessAdminContainer));
